import styled, { css } from 'styled-components';
import { RADIUS_CIRCLE, RADIUS_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';
import { MICRO } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { LINE_HEIGHT_NONE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/lineHeight';
import { FONT_WEIGHT_BOLD } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontWeight';
import { SPACING_2, SPACING_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { SPEED_NORMAL, SPEED_FAST, SPEED_XFAST } from '@nokia-csf-uxr/freeform-design-tokens/tokens/speed';
import { TRANSITION_STANDARD, TRANSITION_DECELERATE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/transition';

import { DEEP_BORDER_BOX, BORDER_BOX } from 'common';
import { getEasing, getDuration } from 'common/parse-tokens';
import { zIndex } from 'styles';

export const EMERGENCY_BADGE_SIZE = '1.5rem';
export const DEFAULT_BADGE_SIZE = '0.9375rem';
export const DEFAULT_BADGE_ICON_SIZE = '0.9375rem';
const BADGE_OVERLAY_SIZE = '1rem';
export const SPRING_CONFIG_NUMBER_BADGE = {
  duration: getDuration(SPEED_NORMAL),
  easing: getEasing(TRANSITION_STANDARD)
};
export const SPRING_CONFIG_DOT_BADGE_NEW = {
  duration: getDuration(SPEED_FAST),
  easing: getEasing(TRANSITION_DECELERATE)
};
export const SPRING_CONFIG_DOT_BADGE_KICK = {
  duration: getDuration(SPEED_XFAST),
  easing: getEasing(TRANSITION_DECELERATE)
};

const TYPOGRAPHY = css`
  ${MICRO}
  line-height: ${LINE_HEIGHT_NONE};
  font-weight: ${FONT_WEIGHT_BOLD};
`;

const EMPTY_STYLE = css`
  box-sizing: content-box;
  border-radius: ${RADIUS_CIRCLE};
  padding: 0;
  max-width: 0.625rem;
  max-height: 0.625rem;
  width: 0.625rem;
  height: 0.625rem;
  min-width: 0.625rem;
  min-height: 0.625rem;
  ${({ $border }) => $border && css`
    // box-shadow: ${props => props.$borderColor} 0rem 0rem 0rem 0.125rem;
    border: 0.125rem solid ${props => props.$borderColor};
    background-clip: padding-box;
  `};
`;

const EMERGENCY_STYLE = css`
  max-width: ${EMERGENCY_BADGE_SIZE};
  max-height: ${EMERGENCY_BADGE_SIZE};
  width: ${EMERGENCY_BADGE_SIZE};
  height: ${EMERGENCY_BADGE_SIZE};
  min-width: ${EMERGENCY_BADGE_SIZE};
  min-height: ${EMERGENCY_BADGE_SIZE};
`;
const DEFAULT_ICON_STYLE = css`
  max-width: ${DEFAULT_BADGE_SIZE};
  max-height: ${DEFAULT_BADGE_SIZE};
  width: ${DEFAULT_BADGE_SIZE};
  height: ${DEFAULT_BADGE_SIZE};
  min-width: ${DEFAULT_BADGE_SIZE};
  min-height: ${DEFAULT_BADGE_SIZE};
`;

export default {
  Badge: styled.div`
    ${BORDER_BOX}
    display: inline-block;
    background-color: ${props => props.$theme.container};
    color: ${props => props.$theme.content};
    ${TYPOGRAPHY}
    padding: ${SPACING_2} ${SPACING_4};
    border-radius: ${RADIUS_4};
    ${props => props.$hasContent ? css`` : EMPTY_STYLE}
  `,

  IconBadge: styled.div`
    ${DEEP_BORDER_BOX}
    position: relative;
    border-radius: ${RADIUS_CIRCLE};
    background-clip: padding-box;
    & svg * {
      fill: ${props => props.$theme.icon};
    }
    ${props => props.$variant === 'default' ? DEFAULT_ICON_STYLE : EMERGENCY_STYLE}
  `,

  BadgeIconWrapper: styled.div`
    height: ${DEFAULT_BADGE_ICON_SIZE};
    width: ${DEFAULT_BADGE_ICON_SIZE};
    & svg {
      z-index: ${zIndex.BADGE};
    }
  `,

  ImageOverlay: styled.div`
    position: absolute;
    ${({ $iconBadge }) => !$iconBadge && css`
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
    `}
    ${({ $iconBadge }) => $iconBadge && css`
      background-color: ${props => props.$borderColor};
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: ${BADGE_OVERLAY_SIZE};
      width: ${BADGE_OVERLAY_SIZE};
    `}
    border-radius: ${RADIUS_CIRCLE};
    opacity: 1;
`
};
